module.exports = __webpack_public_path__ + "static/sponsorship_img1@2x-bf559daa74e8933e6275afa12a1b8352.jpg";